import { createContext } from "react";
import { generateBNDataLayerProvider } from "../helpers/generateBNDataLayerProvider";
export var BNDataLayerCtx = createContext(generateBNDataLayerProvider("", ""));
//# sourceMappingURL=BNDataLayerCtx.js.map